<section class="footer">
  <a *ngFor="let link of links" class="link" [routerLink]="link.path"> {{ link.label }} </a>
</section>
